// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__DCNye","large":"styles_large__1F5sT"};